__turbopack_context__.v({
  "img": "CardImage-module__oe7yJq__img",
  "paper": "CardImage-module__oe7yJq__paper",
});
